import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dbf7678&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4dbf7678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf7678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbf7678')) {
      api.createRecord('4dbf7678', component.options)
    } else {
      api.reload('4dbf7678', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dbf7678&scoped=true&", function () {
      api.rerender('4dbf7678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/transList/index.vue"
export default component.exports